<script lang="ts">
	import { writable } from "svelte/store";
	import { Uploader } from "@wx/svelte-uploader";
	import UploaderList from "./UploaderList.svelte";

	import type { Writable } from "svelte/store";
	import type { IAttachment, TFilesFieldShape, ICard } from "@xbs/lib-kanban";

	export let field: TFilesFieldShape;
	export let values: Writable<ICard>;

	$: files = writable($values[field.key] || []) as Writable<IAttachment[]>;

	let ready = false;
	$: {
		if (ready) {
			$values[field.key] = $files;
		}
		ready = true;
	}

	interface UploadEvent extends PointerEvent {
		id: number;
		status: "client" | "server" | "error";
		name: string;
		file: string | Blob;
	}

	function defaultUploadFunction(obj: UploadEvent): Promise<any> {
		const formData = new FormData();
		formData.append("upload", obj.file);

		const config = {
			method: "POST",
			body: formData,
		};

		return fetch(field.uploadURL, config)
			.then(res => res.json())
			.then(
				data => {
					obj.id = data.id;
					return data;
				},
				() => ({ id: obj.id, status: "error" })
			)
			.catch();
	}

	$: uploadFn =
		typeof field.uploadURL === "function"
			? field.uploadURL
			: defaultUploadFunction;

</script>

<UploaderList data={files} />
<Uploader bind:data={$files} uploadURL={uploadFn} {...field.config} />
